(function () {
  const dataTarget = document.currentScript.dataset.target;

  const hotSpotsContainer = document.querySelector(dataTarget)

  const mediaContainer = hotSpotsContainer.querySelector('.media-with-hotspots__media');
  const descriptions = mediaContainer.querySelectorAll('.hot-spot__description');

  function initializeInteraction() {
    if (descriptions.length <= 0) return;

    if (window.innerWidth <= 768) {
      mediaContainer.addEventListener(
        'click',
        showHotSpotDescription(descriptions)
      );
      document.addEventListener('keydown', keydownDescription(descriptions));
    } else {
      mediaContainer.removeEventListener('click', showHotSpotDescription);
      document.removeEventListener('keydown', keydownDescription);
    }
  }

  function showHotSpotDescription(descriptions) {
    mediaContainer.addEventListener('click', (e) => {
      const x = e.target.closest('.hot-spot__button');
      const index = x ? x.getAttribute('index') : null;

      descriptions.forEach((description) => {
        description.classList.remove('active');
        if (index === description.getAttribute('index')) {
          description.classList.add('active');
        }
      });
    });
  }

  function keydownDescription(descriptions) {
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        descriptions.forEach((description) => {
          description.classList.remove('active');
        });
      }
    });
  }

  initializeInteraction();

  window.addEventListener('resize', initializeInteraction);
})();